import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosClient from "../../axios-client";

const initialState = {
  isFetching: false,
  errorMessage: null,
  filteredPosts: [], // ✅ Only one array now
  recordCount: 0,
};

export const retrievePosts = createAsyncThunk(
  "Posts/retrievePosts",
  async (params = {}, { rejectWithValue, dispatch }) => {
    try {
      const response = await axiosClient.get(`services/getAllPosts`, { params });
      dispatch(updateRecordCount(response.data.TotalCount));
      // Always return an array (avoid undefined)
      return response.data.Items || [];
    } catch (error) {
      console.error("retrievePosts error:", error);
      return rejectWithValue(
        error.response?.data?.message || "Unable to retrieve posts"
      );
    }
  }
);

const PostsSlice = createSlice({
  name: "Posts",
  initialState,
  reducers: {
    resetPosts: (state) => {
      state.filteredPosts = [];
      state.errorMessage = null;
    },
    updateRecordCount: (state, action) => {
      state.recordCount = action.payload;
    },
    updateFilteredPosts: (state, action) => {
      state.filteredPosts = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(retrievePosts.pending, (state) => {
        state.isFetching = true;
        state.errorMessage = null;
      })
      .addCase(retrievePosts.fulfilled, (state, action) => {
        state.isFetching = false;
        state.filteredPosts = action.payload;
      })
      .addCase(retrievePosts.rejected, (state, action) => {
        state.isFetching = false;
        state.errorMessage = action.payload || "An error occurred";
      });
  },
});

export const {
  resetPosts,
  updateRecordCount,
  updateFilteredPosts,
} = PostsSlice.actions;

export default PostsSlice.reducer;
